import React, {useState} from 'react';
import {Text, View , TextInput as NativeTextInput } from 'react-native';
import {TextInput} from 'react-native-paper';
import styles from './LabelField.style';
import { isWeb } from '../../../constants';

export default function LabelField(props) {
  const {labelText, leftChildren, isFocus, setIsFocus, inputStyle, onChangeText} = props;
  const [compositionValue, setCompositionValue] = useState('');

  function onFocus() {
    if (!isFocus) {
      setIsFocus(true);
    }
  }

  function onBlur() {
    setIsFocus(false);
  }

  function handleCompositionStart() {
    setCompositionValue('');
  }

  function handleCompositionUpdate(e) {
    setCompositionValue(e.data || '');
  }

  function handleCompositionEnd(e) {
    const finalValue = e.data || compositionValue;
    setCompositionValue('');
    if (onChangeText && finalValue) {
      onChangeText(finalValue);
    }
  }

  function handleTextChange(text) {
    if (onChangeText) {
      onChangeText(text);
    }
  }

  return (
    <>
      {leftChildren}
      <View style={styles.container}>
        {props?.disabled ? <View style={styles.obstacleView} /> : null }
        <TextInput
          label={<Text style={styles.label}>{labelText}</Text>}
          underlineStyle={styles.underline}
          style={[styles.input, inputStyle ]}
          onBlur={onBlur}
          onFocus={onFocus}
          onChangeText={handleTextChange}
          {...props}
          numberOfLines={isWeb ? undefined : 5 }
          render={(innerProps) => (
            <NativeTextInput
                {...innerProps}
                style={[
                innerProps.style,
                props.multiline
                    ? {
                        paddingTop: 16,
                        paddingBottom: 16,
                        height: 164,
                    }
                    : null,
                ]}
                inputMode={props.keyboardType === 'number-pad' ? 'numeric' : undefined}
                onCompositionStart={handleCompositionStart}
                onCompositionUpdate={handleCompositionUpdate}
                onCompositionEnd={handleCompositionEnd}
            />
            )}
        />
      </View>
    </>
  );
}
